import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, Checkbox, Grid, Row, Col, Tabs, Tab, ButtonToolbar, Button } from 'react-bootstrap';
import Select from "react-select";

import { HandleMessage } from '../../../HandleMessage';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { StopsCommand } from '../../commands/StopsCommand';
import { PathStopsCommand } from '../../commands/PathStopsCommand';
import { OrderSetter } from '../helpers/OrderSetter';
import { ScheduleSetsHelper } from './helpers/ScheduleSetsHelper';
import { TmlScheduleSet } from './tabs/TmlScheduleSet';

export class TmlStopSchedForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dependencies: {
                lines: [],
                stops: []
            },
            form: {
                stop: undefined,
                scheduleSets: []
            },
            render: {
                tab: 1
            },
            sort: {
                column: "code",
                order: "ascending",
            },
            commands: {
                lines: new PathStopsCommand(),
                stops: new StopsCommand()
            },
            actions: {
                isLoadingLines: false,
                isLoadingStops: false,
                isLoadingSchedules: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            transient: {
                selection: {
                    id: undefined,
                    type: 1,
                    dataCode: undefined,
                    scheduleSets: []
                }
            }
        };
    }

    componentDidMount() {
        const { edition } = this.props;

        if (undefined !== edition) {
            edition.addObserver(this);
        }
    }

    componentWillUnmount() {
        const { edition } = this.props;

        if (undefined !== edition) {
            edition.removeObserver(this);
        }
    }

    // ----------------------

    updateNetwork() {
        const { actions, form } = this.state;

        actions.isLoadingStops = true;
        form.stop = undefined;

        this.setState({
            form: form,
            actions: actions
        }, () => {
            this.getStops(this.props.edition);
            this.onChangeStopSelected();
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, action, callback = undefined) {
        const { dependencies, actions } = this.state;

        actions[action] = false;
        dependencies[dataType] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, action) {
        const { dependencies, actions, message } = this.state;

        actions[action] = false;
        dependencies[dataType] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    finalizeGetStopsCallback() {
        const { parentDependencies } = this.props;
        const { dependencies, form } = this.state;
        const { selection } = parentDependencies;

        if (undefined === selection || null === selection || 1 !== selection.layout) {
            // Nothing to be done
            return;
        }

        form.stop = dependencies.stops.find(stop => stop.code === selection.dataCode);

        this.setState({
            form: form
        }, () => this.onChangeStopSelected());
    }

    finalizeGetLinesCallback() {
        const { parentDependencies } = this.props;
        const { dependencies, form, transient } = this.state;
        const { selection } = parentDependencies;

        if (undefined === selection || null === selection || undefined === form.stop) {
            transient.selection.id = 0;

            this.setState({
                transient: transient
            }, () => this.onUpdateData());

            return;
        }

        const dataSelection = selection.selections.find(dataSelection => 1 === dataSelection.type && dataSelection.dataCode === form.stop.code);
        if (undefined === dataSelection) {
            transient.selection.id = 0;
            
            this.setState({
                transient: transient
            }, () => this.onUpdateData());
            
            return;
        }
        
        form.scheduleSets = dataSelection.scheduleSets
            .map(scheduleSet => {
                const setOfDayTypes = parentDependencies.setOfDayTypes.find(set => set.id === scheduleSet.setOfDayTypesId);
                if (undefined === setOfDayTypes) {
                    return null;
                }

                const line = dependencies.lines.find(line => line.code === scheduleSet.lineCode && line.orientation === scheduleSet.lineOrientation);
                if (undefined === line) {
                    return null;
                }

                const filteredSchedules = scheduleSet.schedules
                    .filter(schedule => {
                        const scheduleObj = parentDependencies.schedules.find(parentSchedule => parentSchedule.name === schedule);
                        if (undefined === scheduleObj) {
                            return false;
                        }

                        return undefined !== line &&
                            null !== line &&
                            Array.isArray(scheduleObj.lines) &&
                            scheduleObj.lines.includes(line.id) &&
                            this.isValidSetOfDayTypes(scheduleObj.setOfDayTypes, setOfDayTypes)
                    });

                return {
                    id: scheduleSet.id,
                    selectionId: scheduleSet.id,
                    season: scheduleSet.season,
                    title: scheduleSet.title,
                    alternateText: scheduleSet.alternateText,
                    line: line,
                    setOfDayTypes: setOfDayTypes,
                    schedules: filteredSchedules.slice()
                };
            })
            .filter(scheduleSet => null !== scheduleSet);

        // Update selection transient state
        transient.selection.id = dataSelection.id;

        this.setState({
            form: form,
            transient: transient
        }, () => this.onUpdateData());
    }

    // ----------------------

    getLines(edition) {
        const { form, actions, commands } = this.state;

        if (undefined === form.stop) {
            return;
        }

        commands.lines.listLines(
            edition.network,
            form.stop.id,
            (a) => this.listSuccessCallback(a, "lines", "isLoadingLines", () => this.finalizeGetLinesCallback()),
            (a) => this.listErrorCallback(a, "lines", "isLoadingLines")
        );

        actions.isLoadingLines = true;

        this.setState({
            actions: actions
        });
    }

    getStops(edition) {
        if (0 === edition.network || "0" === edition.network || null === edition.network || undefined === edition.network) {
            this.listSuccessCallback([], "stops", "isLoadingStops", () => this.finalizeGetStopsCallback());
            return;
        }

        const { actions, commands } = this.state;

        commands.stops.list(
            edition.network,
            (a) => this.listSuccessCallback(a, "stops", "isLoadingStops", () => this.finalizeGetStopsCallback()),
            (a) => this.listErrorCallback(a, "stops", "isLoadingStops")
        );

        actions.isLoadingStops = true;

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    onChangeValue(e, property) {
        const { form } = this.state;

        form[property] = e.target.value;

        this.setState({
            form: form,
        }, () => {
            this.onUpdateData();
        });
    }

    onSelectValue(e, property, callback = undefined) {
        const { form } = this.state;

        form[property] = e;

        this.setState({
            form: form
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
            else {
                this.onUpdateData();
            }
        });
    }

    onSelectAllSchedules(scheduleSetId, schedules) {
        const { form } = this.state;

        const scheduleSet = form.scheduleSets.find(scheduleSet => scheduleSet.id === scheduleSetId);
        if (undefined === scheduleSet) {
            return;
        }

        if (scheduleSet.schedules.length >= schedules.length) {
            scheduleSet.schedules = [];
        }
        else {
            scheduleSet.schedules = schedules.map(schedule => schedule.name);
        }

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onScheduleRowClick(scheduleSetId, schedule) {
        const { form } = this.state;

        const scheduleSet = form.scheduleSets.find(scheduleSet => scheduleSet.id === scheduleSetId);
        if (undefined === scheduleSet) {
            return;
        }

        if (scheduleSet.schedules.includes(schedule)) {
            scheduleSet.schedules = scheduleSet.schedules
                .filter(formSchedule => formSchedule !== schedule);
        }
        else {
            scheduleSet.schedules.push(schedule);
        }

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onCheckSetValue(e, set) {
        if (undefined === set || "function" !== typeof this.props.onCheckFilterValue) {
            return;
        }

        if (undefined !== set.first && undefined !== set.first.line) {
            this.props.onCheckFilterValue(e.target.checked, set.first.line.id, set.first.line.orientation);
        }

        if (undefined !== set.second && undefined !== set.second.line) {
            this.props.onCheckFilterValue(e.target.checked, set.second.line.id, set.second.line.orientation);
        }
    }

    onSaveScheduleSet(scheduleSet) {
        const { form } = this.state;

        if (0 === scheduleSet.id) {
            form.scheduleSets.push({
                id: form.scheduleSets.reduce((previous, current) => previous > current.id ? previous : current.id, 0) + 1,
                selectionId: 0,
                line: scheduleSet.line,
                setOfDayTypes: scheduleSet.setOfDayTypes,
                season: scheduleSet.season,
                title: scheduleSet.title,
                alternateText: scheduleSet.alternateText,
                schedules: []
            });
        }
        else {
            const formScheduleSet = form.scheduleSets.find(formScheduleSet => formScheduleSet.id === scheduleSet.id);
            if (undefined === formScheduleSet) {
                return;
            }

            if (formScheduleSet.setOfDayTypes !== scheduleSet.setOfDayTypes) {
                formScheduleSet.setOfDayTypes = scheduleSet.setOfDayTypes;
                formScheduleSet.schedules = [];
            }
            formScheduleSet.season = scheduleSet.season;
            formScheduleSet.title = scheduleSet.title;
            formScheduleSet.alternateText = scheduleSet.alternateText;
        }

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onRemoveScheduleSet(scheduleSetId) {
        const { form } = this.state;

        form.scheduleSets = form.scheduleSets.filter(scheduleSet => scheduleSet.id !== scheduleSetId);

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
    }

    onSaveSchesuleSetsOrder(scheduleSets) {
        const { form } = this.state;

        form.scheduleSets = scheduleSets;

        this.setState({
            form: form
        }, () => {
            this.onUpdateData();
        });
        this.onHideSchedulesSetsOrder();
    }

    onHideSchedulesSetsOrder() {
        this.props.onHideSchedulesSetsOrder();
    }

    onChangeStopSelected() {
        const { edition } = this.props;
        const { form, render, transient } = this.state;

        if (undefined !== form.stop && null !== form.stop) {
            this.props.getSelectionData(form.stop.code, () => this.getLines(edition));
        }

        form.scheduleSets = [];
        render.tab = 1;
        transient.selection.id = undefined;

        this.setState({
            form: form,
            render: render,
            transient: transient
        }, () => this.onUpdateData());
    }

    onUpdateData() {
        const { form, transient } = this.state;

        let data = {};
        if (undefined !== form.stop && null !== form.stop) {
            data = {
                stop: form.stop.id,
                scheduleSets: form.scheduleSets.map(scheduleSet => {
                    return {
                        line: undefined === scheduleSet.line || null === scheduleSet.line ? 0 : scheduleSet.line.id,
                        orientation: undefined === scheduleSet.line || null === scheduleSet.line ? undefined : scheduleSet.line.orientation,
                        setOfDayTypesId: undefined === scheduleSet.setOfDayTypes || null === scheduleSet.setOfDayTypes ? 0 : scheduleSet.setOfDayTypes.id,
                        title: scheduleSet.title,
                        season: scheduleSet.season,
                        alternateText: scheduleSet.alternateText,
                        schedules: scheduleSet.schedules
                    };
                }),
            };

            transient.selection.dataCode = form.stop.code;
            transient.selection.scheduleSets = form.scheduleSets.map(scheduleSet => {
                return {
                    id: scheduleSet.selectionId,
                    lineCode: undefined === scheduleSet.line || null === scheduleSet.line ? "" : scheduleSet.line.code,
                    lineOrientation: undefined === scheduleSet.line || null === scheduleSet.line ? "" : scheduleSet.line.orientation,
                    setOfDayTypesId: undefined === scheduleSet.setOfDayTypes || null === scheduleSet.setOfDayTypes ? 0 : scheduleSet.setOfDayTypes.id,
                    season: scheduleSet.season,
                    title: scheduleSet.title,
                    alternateText: scheduleSet.alternateText,
                    schedules: scheduleSet.schedules.slice()
                };
            });
        }
        else {
            transient.selection.dataCode = undefined;
            transient.selection.scheduleSets = [];
        }

        this.props.onUpdateData(data);
        this.props.onUpdateSelection(transient.selection);
    }

    onTabSelected(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ----------------------

    isValidSetOfDayTypes(scheduleSetOfDayTypes, setSetOfDayTypes) {
        return scheduleSetOfDayTypes.dayTypes.some(scheduleDayType => {
            return undefined !== setSetOfDayTypes.dayTypes.find(setDayType => scheduleDayType.id === setDayType.id)
        });
    }

    // ----------------------

    renderAlertIcon(isGenerated) {
        if (isGenerated) {
            return null;
        }

        return (
            <div className="icon-img icon-alert warning"></div>
        );
    }

    renderForm() {
        const { dependencies, form } = this.state;

        const stops = dependencies.stops
            .sort((a, b) => a.code - b.code);

        return (
            <div>
                <FormGroup controlId="formStop">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Paragem</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Paragem selecionada"
                                noOptionsMessage={() => "Sem Paragens Configuradas"}
                                onChange={(e) => this.onSelectValue(e, "stop", (a) => { this.onChangeStopSelected(a); })}
                                options={stops}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    return form.stop === a;
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => (
                                    <div className="custom-multiselect-label">
                                        {this.renderAlertIcon(label.isGenerated)}
                                        <span>{label.code} | {label.name}</span>
                                    </div>
                                )}
                                filterOption={(candidate, input) => {
                                    if (undefined === input || null === input || "" === input) {
                                        return true;
                                    }

                                    const inputInvariantCase = input.toLowerCase();
                                    const codeInvariantCase = candidate.data.code.toLowerCase();
                                    const nameInvariantCase = candidate.data.name.toLowerCase();

                                    if (codeInvariantCase.includes(inputInvariantCase) || nameInvariantCase.includes(inputInvariantCase)) {
                                        return true;
                                    }

                                    return `${codeInvariantCase} | ${nameInvariantCase}`.includes(inputInvariantCase);
                                }}
                                value={form.stop} />
                        </Col>
                    </Row>
                </FormGroup>
            </div>
        );
    }

    renderSetSeason(key, season) {
        return (
            <div key={`${key}-season-${season.replace(" ", "-")}`} className="tml-stop-sched-schedule-set-season-info">
                <span>{season}</span>
            </div>
        );
    }

    renderScheduleSetLineTabContent(key, edition, lines, setOfDayTypes, schedules, scheduleSet) {
        return (
            <TmlScheduleSet key={`${key}-schedule-set-${scheduleSet.line.code}-${scheduleSet.line.orientation}-${scheduleSet.season}-${scheduleSet.setOfDayTypes.name}`}
                className="padding-0"
                value={scheduleSet}
                edition={edition}
                setOfDayTypes={setOfDayTypes}
                lines={lines}
                schedules={schedules}
                onScheduleRowClick={(a, b) => this.onScheduleRowClick(a, b)}
                onSelectAllSchedules={(a, b) => this.onSelectAllSchedules(a, b)}
                onRemove={(a) => this.onRemoveScheduleSet(a)}
                onSave={(a) => this.onSaveScheduleSet(a)} />
        );
    }

    renderOrderedLineScheduleSetsBySeason(key, edition, lines, setOfDayTypes, schedules, lineSets) {
        if (undefined === lineSets || !Array.isArray(lineSets.sets)) {
            return null;
        }

        const output = [];
        lineSets.sets.forEach(set => {
            const setIndex = output.findLastIndex(orderedSet => undefined !== orderedSet.set && orderedSet.set.season === set.season);
            const setSchedules = schedules.filter(schedule =>
                undefined !== set.line &&
                null !== set.line &&
                Array.isArray(schedule.lines) &&
                schedule.lines.includes(set.line.id) &&
                this.isValidSetOfDayTypes(schedule.setOfDayTypes, set.setOfDayTypes)
            );

            const setObject = {
                set: set,
                render: this.renderScheduleSetLineTabContent(key, edition, lines, setOfDayTypes, setSchedules, set)
            };

            if (-1 === setIndex) {
                output.push({ render: <hr key={`hr-${set.line.code}-${set.line.orientation}-${set.season}`} /> });
                output.push({ render: this.renderSetSeason(key, set.season) });
                output.push(setObject);
                return;
            }

            output.splice(setIndex + 1, 0, setObject)

        });

        return output.map(x => x.render);
    }

    renderLineInformation(scheduleSet) {
        if (undefined === scheduleSet || undefined === scheduleSet.line) {
            return (
                <div className="tml-stop-sched-schedule-set-line-info">
                    <span>Sem Linha</span>
                </div>
            );
        }

        return (
            <div className="tml-stop-sched-schedule-set-line-info">
                <span>{ScheduleSetsHelper.getLineName(scheduleSet)}</span>
            </div>
        );
    }

    renderScheduleSetTabContent(isWaiting, edition, lines, setOfDayTypes, schedules, scheduleSet) {
        if (isWaiting) {
            return <LoadingSpinner />;
        }

        return (
            <Grid fluid>
                <Row>
                    <Col xs={12} sm={6}>
                        {this.renderLineInformation(scheduleSet.first)}
                    </Col>

                    <Col xs={12} sm={6}>
                        {this.renderLineInformation(scheduleSet.second)}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        {this.renderOrderedLineScheduleSetsBySeason("first", edition, lines, setOfDayTypes, schedules, scheduleSet.first)}
                    </Col>

                    <Col xs={12} sm={6}>
                        {this.renderOrderedLineScheduleSetsBySeason("second", edition, lines, setOfDayTypes, schedules, scheduleSet.second)}
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderScheduleSetTab(edition, scheduleSet, tabKey) {
        const { parentDependencies, isLoadingSchedules } = this.props;
        const { dependencies, actions } = this.state;

        const firstLineTitle = ScheduleSetsHelper.getLineShortName(scheduleSet.first);
        const secondLineTitle = ScheduleSetsHelper.getLineShortName(scheduleSet.second);;
        return (
            <Tab eventKey={tabKey}
                key={`schedule-set-${scheduleSet.first.line.code}-${scheduleSet.first.line.orientation}`}
                title={`${firstLineTitle} - ${secondLineTitle}`}>
                {this.renderScheduleSetTabContent(isLoadingSchedules || actions.isLoadingLines, edition, dependencies.lines, parentDependencies.setOfDayTypes, parentDependencies.schedules, scheduleSet)}
            </Tab>
        );
    }

    renderAddTab() {
        const { parentDependencies, isLoadingSchedules } = this.props;
        const { dependencies, actions } = this.state;

        if (actions.isLoadingLines || isLoadingSchedules) {
            return <LoadingSpinner />;
        }

        return (
            <TmlScheduleSet isEditing={true}
                setOfDayTypes={parentDependencies.setOfDayTypes}
                lines={dependencies.lines}
                onSave={(a) => this.onSaveScheduleSet(a)} />
        );
    }

    renderBody() {
        const { form } = this.state;

        if (undefined === form.stop || null === form.stop) {
            return null;
        }

        const { isLoadingSelectionData } = this.props;

        if (isLoadingSelectionData) {
            return (
                <LoadingSpinner />
            );
        }

        const { edition } = this.props;
        const { render } = this.state;

        // Merge form.scheduleSets to the UI merged stuff
        const mergedScheduleSets = ScheduleSetsHelper.mergeScheduleSets(form.scheduleSets);

        let nextTabKey = 1;
        return (
            <Tabs id="tml-stopsched-tabs" activeKey={render.tab} onSelect={(a) => this.onTabSelected(a)}>
                {mergedScheduleSets.map(scheduleSet => this.renderScheduleSetTab(edition, scheduleSet, nextTabKey++))}

                <Tab eventKey={nextTabKey} key="addSchedule" title="+">
                    {this.renderAddTab()}
                </Tab>
            </Tabs>
        );
    }

    renderContent(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return (
            <div>
                {this.renderForm()}
                {this.renderBody()}
            </div>
        );
    }

    renderOrderSetter(isSettingOrder) {
        const { form } = this.state;

        if (!isSettingOrder || 2 > form.scheduleSets.length) {
            return null;
        }

        return (
            <OrderSetter data={form.scheduleSets}
                title="Conjunto de Horários"
                header="Descrição"
                getValueCallback={(a) => `[${a.season}] ${a.line.code} - ${a.title} ## ${a.setOfDayTypes.name}`}
                onSave={(a) => this.onSaveSchesuleSetsOrder(a)}
                onHide={() => this.onHideSchedulesSetsOrder()} />
        );
    }

    renderFilter() {
        const { isToFilter } = this.props;

        if (!isToFilter) {
            return null;
        }

        const { form } = this.state;
        const mergedScheduleSets = ScheduleSetsHelper.mergeScheduleSets(form.scheduleSets);

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Filtrar pares de Linhas a gerar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {
                            mergedScheduleSets.map((set, index) =>
                                <FormGroup key={`available-set-${index}`} controlId={`availableSet${index}`}>
                                    <Checkbox className="form-checkbox"
                                        defaultChecked={true}
                                        onChange={(e) => this.onCheckSetValue(e, set)}>
                                        {ScheduleSetsHelper.getLineShortName(set.first)} - {ScheduleSetsHelper.getLineShortName(set.second)}
                                    </Checkbox>
                                </FormGroup>
                            )
                        }
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.props.onConfirmFilter()}> CONFIRMAR </Button>
                        <Button onClick={() => this.props.onCancelFilter()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        const { isVisible } = this.props;

        if (!isVisible) {
            return null;
        }

        const { isLoadingSetOfDayTypes, isSettingOrder } = this.props;
        const { actions, message } = this.state;

        return (
            <div>
                {this.renderContent(actions.isLoadingStops || isLoadingSetOfDayTypes)}
                {this.renderOrderSetter(isSettingOrder)}
                {this.renderFilter()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}
